import { Button } from 'avo-ui'
import Select from 'components/commons/select'
import Search from 'components/commons/search'
import Sort from 'components/commons/sort'
import PageLimit from 'components/commons/page-limit'
import { FILTER_USER, INIT_STATUS, SORT_USER, TABLE_USER } from 'configs/user/configTableUserList'
import Filter from 'components/commons/filter'
import icLinkExternal from '../../../assets/images/ic-link-external.svg'
import DateRangePicker from 'components/commons/date-range-picker'
import ModalExport from 'components/commons/modal-export'
import Table from 'components/commons/table'
import ModalConfirmation from 'components/commons/modal-confirmation'
import ModalDelete from 'components/commons/modal-delete'
import { getQueryFilter } from 'utils/utils'

export const UserList = ({
    dataList,
    modal,
    setShowModal,
    onSelectSort,
    query,
    onChangeQuery,
    queryFilter,
    onApply,
    modalMessage,
    selectedIds,
    selectedStatus,
    onExport,
    onSelectItemHandler,
    setSelectedStatus,
    isLoading,
    confirmBulkActionHandler,
    isResetSelectedItem,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex gap-x-3'}>
                    <div className={'flex space-x-3'}>
                        <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                        <DateRangePicker
                            value={query?.start_date ? [query?.start_date, query?.end_date] : []}
                            onChange={(value) => onChangeQuery({ page: 1, start_date: value[0], end_date: value[1] })}
                            format={'YYYY-MM-DD'}
                        />
                        <Sort
                            options={SORT_USER}
                            value={`${query?.order_by}-${query?.order_type}`}
                            onSelect={(value) => onSelectSort(value)}
                        />
                    </div>
                    <Filter
                        show={modal?.filter}
                        setShow={(value) => setShowModal({ filter: value })}
                        options={FILTER_USER}
                        values={queryFilter}
                        onSubmit={(value) => onChangeQuery(getQueryFilter(value))}
                    />
                    <div className={'flex space-x-3'}>
                        <PageLimit
                            value={query?.limit}
                            onSelect={(value) => onChangeQuery({ limit: value, page: 1 })}
                        />
                        <Button
                            title={'Export'}
                            icon={icLinkExternal}
                            type={'outline'}
                            disabled={!dataList?.total_result}
                            onClick={() => setShowModal({ export: true })}
                        />
                    </div>
                </div>
                <div className={'flex space-x-3'}>
                    <Select
                        name={'status'}
                        className={'w-32'}
                        placeholder={'Select Status'}
                        options={INIT_STATUS}
                        value={selectedStatus}
                        onChange={(item) => setSelectedStatus(item.value)}
                    />
                    <Button title={'Apply'} onClick={onApply} disabled={!selectedIds?.length} />
                </div>
            </div>
            <Table
                className={'my-3'}
                name={TABLE_USER.name}
                columns={TABLE_USER.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                isResetSelectedItem={isResetSelectedItem}
            />
            {modal?.export && (
                <ModalExport
                    show={modal?.export}
                    onHide={() => setShowModal({ export: false })}
                    description={'Are You Sure Export This?'}
                    totalData={selectedIds?.length || dataList?.total_result}
                    isLoading={false}
                    onExport={onExport}
                />
            )}
            {modal?.confirm && (
                <ModalConfirmation
                    show={modal?.confirm}
                    onHide={() => setShowModal({ confirm: false })}
                    description={modalMessage}
                    totalData={selectedIds?.length}
                    isLoading={false}
                    onConfirm={() => confirmBulkActionHandler('confirm')}
                />
            )}
            {modal?.delete && (
                <ModalDelete
                    show={modal?.delete}
                    onHide={() => setShowModal({ delete: false })}
                    description={modalMessage}
                    totalData={selectedIds?.length}
                    isLoading={false}
                    onDelete={() => confirmBulkActionHandler('delete')}
                />
            )}
        </div>
    )
}
